import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import Icon from '../Icon';

class ConfirmDialog extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showContainer: false
		};

		this.handleClick = this.handleClick.bind(this);
	}

	componentWillMount() {
		document.addEventListener('click', this.handleClick, false);
	}

	componentWillUnmount() {
		document.removeEventListener('click', this.handleClick, false);
	}

	handleClick(e) {
		if (this.node.contains(e.target)) {
			return false;
		}

		this.props.closeDialogClicked(e);
	}

	render() {
		const {
			id,
			styles,
			icon,
			title,
			description,
			cancelButton,
			acceptButton,
			closeDialogClicked,
			confirmClicked,
			theme,
			body,
			height
		} = this.props;

		const containerStyles = {
			minHeight: '290px',
			height: 'auto',
			top: `calc(50% - ${height})`
		};

		return id ? (
			<div className="ConfirmDialog" style={styles}>
				<div
					className="ConfirmDialog-container"
					ref={node => (this.node = node)}
					style={containerStyles}
				>
					<div className="ConfirmDialog-content">
						{icon && (
							<div className="ConfirmDialog-icon">
								<Icon icon={icon} />
							</div>
						)}
						<h3 className="ConfirmDialog-title">{title}</h3>
						{body}
						{description && (
							<div
								className="ConfirmDialog-description"
								dangerouslySetInnerHTML={{ __html: description }}
							/>
						)}
					</div>
					<div className="ConfirmDialog-footer">
						<button
							className="ConfirmDialog-button"
							onClick={closeDialogClicked}
						>
							{cancelButton}
						</button>
						<button
							className={`ConfirmDialog-button ConfirmDialog-button--${theme}`}
							onClick={confirmClicked}
						>
							{acceptButton}
						</button>
					</div>
				</div>
			</div>
		) : (
			<div className="ConfirmDialog" style={styles}>
				<div
					className="ConfirmDialog-container"
					ref={node => (this.node = node)}
				>
					<span className="ConfirmDialog-error">
						Record is missing!<br />Contact tech assistant!
					</span>
				</div>
			</div>
		);
	}
}

ConfirmDialog.propTypes = {
	id: PropTypes.string,
	closeDialogClicked: PropTypes.func,
	styles: PropTypes.object,
	show: PropTypes.bool,
	icon: PropTypes.string,
	title: PropTypes.string,
	description: PropTypes.string,
	cancelButton: PropTypes.string,
	acceptButton: PropTypes.string,
	cancelClicked: PropTypes.func,
	acceptClicked: PropTypes.func,
	confirmClicked: PropTypes.func,
	height: PropTypes.number
};

ConfirmDialog.defaultProps = {
	show: false,
	title: 'Deleting record',
	description:
		'Are you sure you want to delete this record?<br />Once deleted it cannot be recovered.',
	cancelButton: 'Cancel',
	acceptButton: 'yes, delete',
	theme: 'red',
	height: 290
};

export default ConfirmDialog;
